import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

@Component({
  template: ""
})
export class ComponentSubscriber implements OnDestroy {
  // #region Properties (1)

  /**
   * Collection of subscriptions added.
   * Normally this stores "one-off" subscriptions like take(1) of Selectors. 
   */
  public subscriptions: {
    name: string,
    subscription: Subscription
  }[] = []

  // #endregion (1)

  // #region Constructors (1)

  constructor() { }

  // #endregion (1)

  // #region Public Methods (1)

  /**
   * Angular Lifecycle hook.
   * When destroying components, unsubscribe any subscriptions to avoid memory leak. 
   */
  public ngOnDestroy() {
    try {
      this.unsubscribeAll()
    } catch (error) {
      console.error(error)
    }
  }
  public unsubscribeAll(){
    try {
      // console.debug(`[NGLC] Component destroyed, now clearing ${this.subscriptions.length} subscription(s)...`)
      // console.log(`[NGLC] Component destroyed, now clearing ${this.subscriptions.length} subscription(s)...`)
      this.subscriptions.forEach(
        item => {
          // console.log(`[NGLC] Unsubscribing ${item.name}`)
          // console.debug(`[NGLC] Unsubscribing ${item.name}`)
          item.subscription.unsubscribe()
        }
      )
    } catch (error) {
      console.error(error)
    }

  }

  // #endregion (1)
}